/* Load Hammer.js for swipe triggers. */
import "hammerjs";
import { initPlayer } from "./video.js";

export const fadeSlide = () => {
  const currentEvidenceContainer = document.querySelector(`.gallery__figure a`);

  currentEvidenceContainer.classList.add("fading");
  setTimeout(() => {
    currentEvidenceContainer.classList.remove("fading");
  }, 250);
};

const init = (currentEvidence, evidence, callback) => {
  const hammertime = new Hammer(document.querySelector(".gallery__main"), {});
  hammertime.get("swipe").set({ direction: Hammer.DIRECTION_ALL });

  hammertime.on("swiperight", function (e) {
    let previousSlide;

    for (var key in evidence) {
      if (evidence.hasOwnProperty(key)) {
        if (evidence[key] === currentEvidence) {
          previousSlide =
            parseInt(key) > 0 ? evidence[parseInt(key) - 1] : null;

          fadeSlide();
          if (!!previousSlide) {
            callback(previousSlide.id);
          }
        }
      }
    }
  });

  hammertime.on("swipeleft", function (e) {
    let nextSlide;

    for (var key in evidence) {
      if (evidence.hasOwnProperty(key)) {
        if (evidence[key] === currentEvidence) {
          nextSlide =
            evidence.length > parseInt(key) + 1
              ? evidence[parseInt(key) + 1]
              : null;

          fadeSlide();

          if (!!nextSlide) {
            callback(nextSlide.id);
          }
        }
      }
    }
  });

  if (currentEvidence.type === "video") {
    initPlayer(currentEvidence.video.video);
  }

  const dots = document.querySelector(".gallery__dots");
  if (!!dots) {
    function getElementHeight(galleryType) {
      if (galleryType === "image") {
        const image = document.querySelector(".gallery__figure img");
        dots.style.top = image.offsetHeight + 24 + "px";
      } else if (galleryType === "video") {
        const iframe = document.querySelector(".gallery__figure iframe");
        dots.style.top = iframe.offsetHeight + 72 + "px"; // include video controls in calculation
      }
    }
    const galleryType = document.querySelector(".gallery__figure > div").dataset
      .type;
    getElementHeight(galleryType);

    window.addEventListener("resize", () => {
      const galleryType = document.querySelector(".gallery__figure > div")
        .dataset.type;
      getElementHeight(galleryType);
    });
  }
};

export default init;
